<template>
  <card
    :headerClasses="headerColor"
    class="no-border-card"
    body-classes="px-0 pb-1"
    footer-classes="pb-2"
  >
    <b-row align-v="center" slot="header">
      <b-col cols="8">
        <h3 class="mb-0 text-white">{{ title }}</h3>
      </b-col>
      <b-col cols="4" class="text-right">
       <!-- <div class="btn btn-sm bg-white">+</div>-->        
        <i class="ni ni-cloud-download-95 text-white" v-on:click="downloadAsCSV" title="baixar despesas em CSV (excel)"></i>
      </b-col>
    </b-row>

    <b-col
      cols="12"
      class="d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <el-select
        class="select-primary pagination-select"
        v-model="pagination.perPage"
        placeholder="Per page"
      >
        <el-option
          class="select-primary"
          v-for="item in pagination.perPageOptions"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>

      <div>
        <base-input
          v-model="searchQuery"
          prepend-icon="fas fa-search"
          placeholder="Filtrar..."
        >
        </base-input>
      </div>
    </b-col>
    <!-- método para somar valores da tabela.
      show-summary 
      :summary-method="getSummaries"-->
    <el-table
      :data="queriedData"
      :row-key="row => row.id"
      header-row-class-name="thead-light"
      @sort-change="sortChange"
      @selection-change="selectionChange"
      :expand-row-keys="expandRowKeys"
      @expand-change="handleExpandChange"
    >
      <el-table-column type="expand" >
        <template slot-scope="props">
          <div class="expand-content">
            <p class="pa-0">Pago em: {{ props.row.p }}</p>
            <p>Descrição: {{ props.row.t }}</p>
            <p>Valor: {{ props.row.v }}</p>
            <p>Previsão: {{ props.row.d }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="column in tableColumns"
        :key="column.label"
        v-bind="column"
      >
      </el-table-column>
    </el-table>
    <div
      slot="footer"
      class="col-12 pa-0 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div :ref="getSummaries()" class="">
        <h5 class="h5">
          Total pago: <span method="" class="font-weight-light">{{totalPago}}</span>
        </h5>
        <h5 class="h5">
          Total previsto: <span class="font-weight-light">{{totalPrevisto}}</span>
        </h5>
        <h5 class="h5">
          A pagar: <span class="font-weight-light">{{diferenca}}</span>
        </h5>
      </div>
    </div>

    <div
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          Mostrando {{ from + 1 }} a {{ to }} de {{ total }} entradas

          <span v-if="selectedRows.length">
            &nbsp; &nbsp; {{ selectedRows.length }} linhas selecionadas
          </span>
        </p>
      </div>
      <base-pagination
        class="pagination-no-border"
        :current="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
        @change="paginationChanged($event)"
      >
      </base-pagination>
    </div>
  </card>
  <!-- </div>
    </b-container>
  </div> -->
</template>
<script>
import { Table, TableColumn, Select, Option, Form, FormItem } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  props: {
    title: {
      type: String
    },
    headerColor: {
      type: String
    },
    data: {
      type: Array,
      default: () => {}
    }
  },
  computed: {
    converteValor(tableRow) {
      console.log("tableRow", tableRow);
      return tableRow;
    }
  },
  data() {
    return {
      expandRowKeys: [],
      totalPago: 0,
      totalPrevisto: 0,
      diferenca: 0,
      pagoTemp: 0,
      prevTemp: 0,
      tableColumns: [
        {
          prop: "p",
          label: "Pago em",
          minWidth: 160,
          formatter: (row, col, cell, index) => this.formatterData(row),
          sortable: true
        },
        {
          prop: "t",
          label: "Descrição",
          minWidth: 220,
          sortable: true
        },
        {
          prop: "v",
          label: "Valor",
          validator: function (value) {
            // O valor precisa corresponder a alguma dessas Strings
             return ['success', 'warning', 'danger'].indexOf(value) !== -1
          },
          minWidth: 135,
          formatter: (row, col, cell, index) => this.formatterMoeda(row),
          sortable: true
        },
        {
          prop: "d",
          label: "Previsão",
          minWidth: 100,
          formatter: (row, col, cell, index) => this.formatterDataPrevisao(row),
          sortable: true
        }
      ],
      tableData: this.data,
      selectedRows: []
    };
  },
  watch: {
    data(newValue, oldValue) {
      this.tableData = newValue;
    }
  },
  mounted() {
    this.createFuseSearch(["name", "position", "date"]);
    //this.getSummaries();
  },
  methods: {
    downloadAsCSV(){
      var mat = this.tableData.map(function(val){
        let cats = val.cat;
        cats = val.cat.split(': ') || []
        let mainCat = cats[0]
        cats = cats.slice(1)
        let subcats = cats.join(',') 
          return [
              //id da transação
              ''+val.id, 
              //paid, quando pago. undefined para pendentes
              val.p?val.p:'--', 
              //third, descrição (rótulo) da saída 
              val.t, 
              //value
              `"${(val.v * 1).toFixed(2).replace('.',',')}"`,  
              //data previsão
              val.d, 
              //forma de pagamento
              val.pm ? (`${JSON.parse(localStorage.getItem('cakeuserdata')).paymentMethods[val.pm] || 'Outra'}`):'--', 
              //id do agent (fornecedor) - Nome do fornecedor
              val.aid ? (val.aid + ' - ' + val.cid): '--', 
              //Categoria
              mainCat || '--',
              //Subcategoria
              `"${cats != ''?cats:'--'}"`,
          ]
      })

      mat.unshift([
          'ID','Pago','Descrição', 'Valor','Previsão','Forma de pagamento','Fornecedor','Categoria','Subategorias',
      ]);

      var universalBOM = "\uFEFF";
      let csvContent = "data:text/csv;charset=utf-8,"  + universalBOM+ mat.map(e => e.join(";")).join("\n");
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${JSON.parse(localStorage.getItem('cakeuserdata')).user.username}_bocapio_despesas_financeiras.xls`);
      document.body.appendChild(link);

      link.click();
    },
    paginationChanged(page) {
      this.pagination.currentPage = page;
    },
   
    getSummaries() {
      //getSummaries(param) {
      //console.log("param", param);
      //const { columns, data } = param;
      //console.log("columns", columns);
      //console.log("data", data);
      //const values = data.map(item => Number(item.v));
      const values = this.tableData.map(item => Number(item.v));
      //console.log("values", values);
      console.log("tableData", this.tableData);
      
      if (!values.every(value => isNaN(value))) {
          let sum = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          //console.log("sum financeiroTable", sum);
          this.prevTemp = sum;
          this.totalPrevisto = sum.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
          });
        }
      //const valorRecebido = data.map((element) => {
        const valorRecebido = this.tableData.map((element) => {
        if (element.d === element.p || element.hasOwnProperty("p")) {
            return Number(element.v)
        }
      });
       if (!valorRecebido.every(value => isNaN(value))) {
          let sumPago = valorRecebido.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          this.pagoTemp = sumPago;
          this.totalPago = sumPago.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
          });
        }
      var difTemp = this.prevTemp - this.pagoTemp;
      this.diferenca = difTemp.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
      });

    },
    
    formatterMoeda(row) {
      //.replace(/"/g,"")
      // console.log("row", parseFloat(row.v.replace(",", ".")));
      var valorFormatado = "R$ " + (row.v * 1).toFixed(2);
      // console.log("valorFormatado", valorFormatado);
      return valorFormatado ;
      
    },
     
    formatterData(row) {
      let dataFormatada = '--'
      if( row.p !== undefined ){
        dataFormatada = row.p.replace(/(\d*)-(\d*)-(\d*).*/, '$3/$2/$1');
      }
      //console.log("data Formatada", dataFormatada);
      return dataFormatada;
    },
    formatterDataPrevisao(row) {
      let dataFormatada = row.d.replace(/(\d*)-(\d*)-(\d*).*/, '$3/$2/$1');
      //console.log("data Formatada", dataFormatada);
      return dataFormatada;
    },
    handleLike(index, row) {
      swal({
        title: `You liked ${row.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill"
      });
    },
    handleEdit(index, row) {
      swal({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-info btn-fill"
      });
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    sortChange(sortProps){
       //console.log("param", param);
      //this.headerClick(sortProps.column) //optional: trigger header-click event
      if (sortProps.prop === 'v') {
       console.log("this.data", sortProps.column);
        const values = this.data.map(item => Number(item.v));
        console.log("values", prop.v);
        var ordem = [];
        if (sortProps.column.order === 'ascending') {
          ordem = values.sort(function(a, b){
            return a - b;
          });
        } else if (sortProps.column.order === 'descending') {
          ordem = values.sort(function(a, b){
            return b - a;
          });
        }
        console.log("ordem", ordem);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    handleExpandChange(row, expandedRows) {
      const id = row.id;
      const lastId = this.expandRowKeys[0];
      // disable mutiple row expanded
      this.expandRowKeys = id === lastId ? [] : [id];
    }
  }
};
</script>
<style>
@import url("//unpkg.com/element-ui@2.4.11/lib/theme-chalk/index.css");
.card .table td,
.card .table th,
.card .el-table td,
.card .el-table th {
  padding-left: 1rem;
  padding-right: 1rem;
}

.expand-content {
  margin-left: 40px;
}
</style>
